<template>
  <RastreoEnvio
    titulo="Rastreo Provincia"
    subtitulo="Consulta el estado, los datos y las evidencias de un envío a provincia."
    icono="bi bi-geo-alt"
    ejemplo="ANW-P-00000423"
    endpoint="tracking"
    campo-estado="id_estados_envio"
    campo-estado-archivo="id_estados_envio"
    :pasos="pasos"
    :paso-entregado="7"
    :especiales="especiales"
    :datos="datos"
  />
</template>

<script>
import RastreoEnvio from '@/components/RastreoEnvio.vue'

// Estados de envíos a provincia (tabla estados_envio). Antes faltaban el 3, 6 y 10, y el 4 y 5
// tenían otros nombres: con esos estados el progreso no marcaba ningún paso.
const PASOS = [
  { ids: [1],          titulo: 'Solicitud Recibida',       icono: 'bi bi-inbox' },
  { ids: [2],          titulo: 'Solicitud Aprobada',       icono: 'bi bi-check2-square' },
  { ids: [3, 4, 5, 6], titulo: 'Recojo',                   icono: 'bi bi-truck' },
  { ids: [7],          titulo: 'Embarque / Despacho',      icono: 'bi bi-box-seam' },
  { ids: [8],          titulo: 'Traslado en Curso',        icono: 'bi bi-signpost-split' },
  { ids: [9],          titulo: 'Llegada a Destino',        icono: 'bi bi-geo-alt' },
  { ids: [10],         titulo: 'Entrega en Curso',         icono: 'bi bi-truck-front' },
  { ids: [11],         titulo: 'Entregado',                icono: 'bi bi-box2-heart' },
  { ids: [12],         titulo: 'Cargo PDF Subido',         icono: 'bi bi-file-earmark-arrow-up' },
  { ids: [13],         titulo: 'Cargo Físico Entregado',   icono: 'bi bi-envelope-check' },
  { ids: [19],         titulo: 'Estado Documentario',      icono: 'bi bi-file-earmark-text' },
]

const ESPECIALES = {
  14: { texto: 'Servicio rechazado', color: 'naranja', icono: 'bi bi-slash-circle-fill' },
  15: { texto: 'Servicio reprogramado', color: 'naranja', icono: 'bi bi-arrow-repeat' },
  16: { texto: 'Servicio cancelado', color: 'roja', icono: 'bi bi-x-circle-fill' },
  17: { texto: 'Retorno al origen', color: 'naranja', icono: 'bi bi-arrow-return-left' },
  18: { texto: 'Mercadería / documento retornado', color: 'naranja', icono: 'bi bi-arrow-return-left' },
}

export default {
  name: 'TrackingPage',
  components: { RastreoEnvio },
  data() {
    return { pasos: PASOS, especiales: ESPECIALES }
  },
  methods: {
    datos(e, f) {
      const entregaReal = !!e.fecha_entrega_real
      return [
        { etiqueta: 'Origen', icono: 'bi bi-box-arrow-up-right', valor: f.empresaSucursal(e.empresa_sucursal), detalle: e.ubicacion_remitente, ancho: true },
        { etiqueta: 'Destino', icono: 'bi bi-geo', valor: f.empresaSucursal(e.empresa_sucursal_destino), detalle: e.ubicacion_destinatario, ancho: true },
        { etiqueta: 'Salida', icono: 'bi bi-calendar-event', valor: f.unir(f.fecha(e.fecha_salida), f.hora(e.horario_salida)) },
        {
          etiqueta: 'Entrega', icono: 'bi bi-calendar-check',
          valor: entregaReal
            ? f.unir(f.fecha(e.fecha_entrega_real), f.hora(e.hora_entrega_real))
            : f.unir(f.fecha(e.fecha_entrada), f.hora(e.horario_entrega)),
          detalle: entregaReal ? 'Fecha real' : 'Programada',
        },
        { etiqueta: 'Servicio', icono: 'bi bi-truck', valor: f.unir(e.tipo_envio, e.modalidades_envio), detalle: e.tipo_unidad_detalle },
        { etiqueta: 'Lead time', icono: 'bi bi-stopwatch', valor: e.lead_time_esperado },
        { etiqueta: 'Guía de remisión', icono: 'bi bi-receipt', valor: e.guias_concatenadas },
        { etiqueta: 'Guía transportista', icono: 'bi bi-receipt-cutoff', valor: e.guias_transportistas_concatenadas },
        { etiqueta: 'Pedido / OC', icono: 'bi bi-bag', valor: f.unir(e.pedidos_concatenados, e.oc_concatenadas) },
        { etiqueta: 'Factura', icono: 'bi bi-file-earmark-ruled', valor: e.facturas_concatenadas },
        { etiqueta: 'Documentos', icono: 'bi bi-paperclip', valor: e.documentos_extras_concatenadas },
        { etiqueta: 'Bultos', icono: 'bi bi-boxes', valor: e.cant_bultos },
        { etiqueta: 'Área solicitante', icono: 'bi bi-person-badge', valor: e.area_solicitante, detalle: e.solicitante },
        { etiqueta: 'Observaciones', icono: 'bi bi-chat-square-text', valor: e.observaciones, completo: true },
      ]
    },
  },
}
</script>
